import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';
import { productsData } from '../data/products';

const PRODUCT_IMG = '/images/logo.png';

export default function Products() {
  const products = productsData;
  
  return (
    <div className="min-h-screen bg-white">
      <PublicNav activeItem="Products" />

      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-accent mb-4">OUR PRODUCTS</p>
            <h1 className="text-5xl sm:text-6xl tracking-tighter font-light text-brand-primary font-outfit">Complete Water Solutions</h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {products.map((product, index) => (
              <motion.div
                key={product.id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white p-8 border border-slate-200 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
              >
                <div className="mb-4">
                  {product.image ? (
                    <a
                      href={product.image}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="h-24 mx-auto"
                      />
                    </a>
                  ) : (
                    <img src={PRODUCT_IMG} alt={product.name} className="h-24 mx-auto" />
                  )}
                </div>
                <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-accent mb-2">{product.category}</p>
                <h3 className="text-xl font-medium text-brand-primary mb-2">{product.name}</h3>
                <p className="text-2xl font-bold text-brand-accent mb-3">Rs. {product.price}</p>
                <p className="text-base text-slate-600">{product.description}</p>
              </motion.div>
            ))}
          </div>

          {/* WhatsApp Button Section */}
          <div className="mt-16 text-center">
            <p className="text-lg text-slate-600 mb-6">Ready to order?</p>
            <a
              href="https://wa.me/923017196699"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-brand-accent text-white hover:bg-brand-accent-hover px-8 py-3 shadow-sm transition-all duration-200"
            >
              Order via WhatsApp
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );

}